// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import cookie from 'js-cookie';

export default class FilterHandler extends WebComponent {
  constructor(props) {
    super(props);
    this.handleToggleLink = this.handleToggleLink.bind(this);
  }

  didMount() {
    this.filterCheckboxMaxItems = 8;

    let filterCheckedItems;
    let filterActive = 0;
    let filterSelected = '';
    const filterSelectedMaxItems = 2;

    let rangeSlider = this.element.querySelector('.range-slider');
    let selectedItems = 0;

    // checkboxy
    if (!rangeSlider) {
      // count content

      filterCheckedItems = this.element.querySelectorAll('.form-group__control:checked');
      filterActive = filterCheckedItems.length;

      filterCheckedItems.forEach((filterCheckedItem) => {
        selectedItems = selectedItems + 1;
        if (selectedItems <= filterSelectedMaxItems) {
          if (filterSelected != '') {
            filterSelected = filterSelected + ', ';
          }
          filterSelected = filterSelected + this.element.querySelector(`label[for='${filterCheckedItem.id}']`)
            .textContent
            .trim();
        }
      });

      if (filterActive > filterSelectedMaxItems) {
        let diff = filterActive - filterSelectedMaxItems;
        filterSelected = filterSelected + ' <span>+' + diff + ' ' + this.getLocale(diff) + '</span>';
      }

      // sbalovani na maximalni pocet checkboxu
      this.filterAllItems = this.element.querySelectorAll('.checkbox-group__item');

      if (this.filterAllItems.length > this.filterCheckboxMaxItems) {
        this.toggleLink = document.createElement('a');
        this.toggleLink.classList.add('filter-group__toggle-link');
        this.toggleLink.innerHTML = '';
        this.toggleLink.addEventListener('click', this.handleToggleLink);
        this.element.querySelector('.filter-group__content').appendChild(this.toggleLink);
        this.updateToggleLink(this.element, false);
      }
    }
    // rangeSlider
    else {
      let rangeSliderValue = this.element.querySelector('.range-slider__value').value;
      let histogramData = rangeSlider.dataset.histogram;
      if (typeof histogramData === 'string') {
        histogramData = JSON.parse(histogramData);
        if (rangeSliderValue != `${histogramData.min},${histogramData.max}`) {
          filterActive = 1;
          filterSelected = `${this.element.querySelector('[data-fragment="input-min"]').value} &ndash; ${this.element.querySelector('[data-fragment="input-max"]').value} ${this.element.querySelector('.range-slider__control-unit').textContent}`;
        }
      }
    }

    //prepare HTML
    let filterGroupHeader = this.element.querySelector('.filter-group__header');
    filterGroupHeader.insertAdjacentHTML('beforeend', `<span class="filter-group__counter">${filterActive}</span><span class="filter-group__selected">${filterSelected}</span>`);

    if (filterActive != 0) {
      filterGroupHeader.classList.add('filter-group__header--selected-items');
    } else {
      filterGroupHeader.classList.remove('filter-group__header--selected-items');
    }
  }

  getLocale(i) {
    let result;

    if (i == 1) {
      result = this.i18n('other1');
    } else if (i > 1 && i < 5) {
      result = this.i18n('other2');
    } else {
      result = this.i18n('other5');
    }
    return result;
  }

  handleToggleLink(e) {
    e.preventDefault();
    const group = e.target.closest('.category-filter__group');
    this.updateToggleLink(group, true);
  }

  updateToggleLink(group, toggle) {
    const stateGroupCookie = this.getStateGroupFromCookie(group.id);

    if (toggle && stateGroupCookie === 'false') {
      this.saveStateGroupToCookie(group.id, 'true');
      this.renderLessState();
    }

    if (toggle && stateGroupCookie === 'true') {
      this.saveStateGroupToCookie(group.id, 'false');
      if (!this.isElementInViewport(group)) {
        group.scrollIntoView();
      }
      this.renderMoreState();
    }

    if (!toggle && stateGroupCookie === 'false') {
      this.renderMoreState();
    }

    if (!toggle && stateGroupCookie === 'true') {
      this.renderLessState();
    }
  }

  renderMoreState() {
    this.filterAllItems.forEach((filterItem, i) => {
      if ((i + 1) > this.filterCheckboxMaxItems) {
        filterItem.classList.add('hidden');
      }
    });
    const diff = this.filterAllItems.length - this.filterCheckboxMaxItems;

    this.toggleLink.innerHTML = `+ ${diff} ${this.getLocale(diff)}`;
  }

  renderLessState() {
    this.filterAllItems.forEach((filterItem) => {
      filterItem.classList.remove('hidden');
    });
    this.toggleLink.innerText = this.i18n('less');
  }


  saveStateGroupToCookie(id, state) {
    cookie.set(`fh_${window.location.pathname}_${id}`, state);
  }

  getStateGroupFromCookie(id) {
    let cookieValue = cookie.get(`fh_${window.location.pathname}_${id}`);
    if (typeof (cookieValue) !== 'undefined') {
      return cookieValue;
    }
    return 'false';
  }

  isElementInViewport(el) {
    let rect = el.getBoundingClientRect();

    return rect.bottom > 0 &&
      rect.right > 0 &&
      rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight);
  }

}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/FilterHandler.js